var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.shopImg),function(item,i){return _c('div',{key:i,staticClass:"adv-img"},[_c('a',{attrs:{"href":item.url}},[_c('img',{attrs:{"src":item.image_url,"alt":""}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }